import { Icons } from "@airhelp/react-ui-components";
import type { ChakraProps } from "@chakra-ui/react";
import type { ChecklistIconTypes } from "./CheckList.d";

const checkListPadding: Record<"fill" | "contain", ChakraProps["padding"]> = {
  fill: 0,
  contain: 6,
};

const CheckListIcons: ChecklistIconTypes = {
  warning: { icon: Icons.BoxImportant, color: "warning.400" },
  success: { icon: Icons.Ok, color: "success.600" },
};

export { checkListPadding, CheckListIcons };
